import React from 'react';
import '../styles/Loading.css'

const Loading = () => (

  <div className="loading" data-test="loading">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default Loading;